import { render, staticRenderFns } from "./BatchIgnore.vue?vue&type=template&id=24c5c3c3"
import script from "./BatchIgnore.vue?vue&type=script&lang=js"
export * from "./BatchIgnore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports